import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  Filter,
  FilterSingle,
} from '@unite-us/app-components';
import { NETWORK_SCOPE_OPTIONS, SORT_OPTIONS } from 'src/components/Browse/utils/filters/constants';

const NetworkActionsBarFilters = ({
  hideServiceTypeFilter,
  onNetworkScopeFilterChange,
  onServiceTypeFilterChange,
  onSortFilterChange,
  serviceTypeOptions,
  filterSort,
}) => {
  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  const [selectedNetworkScopes, setSelectedNetworkScopes] = useState([]);

  // Helper function to generate filter names with counts
  const createFilterName = (baseName, selectedCount = 0) => {
    const formatFilterName = (name, count) => {
      if (count === 0) return name;
      if (count === 1) return `${name}(1)`;
      return `${name}(${count})`;
    };

    const pluralMap = {
      'Service Type': 'Service Types',
      'Network Scope': 'Network Scopes',
    };

    const displayName = selectedCount > 1 ? (pluralMap[baseName] || baseName) : baseName;
    return formatFilterName(displayName, selectedCount);
  };

  // Helper function to handle service type filter changes
  const handleServiceTypeChange = (selectedOptions) => {
    const options = selectedOptions || [];
    setSelectedServiceTypes(options);
    onServiceTypeFilterChange(selectedOptions);
  };

  // Helper function to handle network scope filter changes
  const handleNetworkScopeChange = (selectedOptions) => {
    const options = selectedOptions || [];
    setSelectedNetworkScopes(options);
    onNetworkScopeFilterChange(selectedOptions);
  };

  // Helper function to render service type filter
  const renderServiceTypeFilter = () => {
    if (hideServiceTypeFilter) return null;

    return (
      <Filter
        hideSelectAll
        id="service-types"
        name={createFilterName('Service Type', selectedServiceTypes.length)}
        onFiltersChange={handleServiceTypeChange}
        options={serviceTypeOptions}
        printRender
      />
    );
  };

  // Helper function to render network scope filter
  const renderNetworkScopeFilter = () => (
    <Filter
      id="network-scopes"
      name={createFilterName('Network Scope', selectedNetworkScopes.length)}
      onFiltersChange={handleNetworkScopeChange}
      options={NETWORK_SCOPE_OPTIONS}
    />
  );

  return (
    <div className="network-actions-bar-filters network-actions-bar-filters__dropdown-filters">
      {renderServiceTypeFilter()}
      {renderNetworkScopeFilter()}
      <FilterSingle
        id="sort-by-select"
        placeholder="Sort By"
        options={SORT_OPTIONS}
        onFilterChange={onSortFilterChange}
        value={filterSort}
      />
    </div>
  );
};

NetworkActionsBarFilters.propTypes = {
  hideServiceTypeFilter: PropTypes.bool,
  onNetworkScopeFilterChange: PropTypes.func.isRequired,
  onSortFilterChange: PropTypes.func.isRequired,
  onServiceTypeFilterChange: PropTypes.func.isRequired,
  serviceTypeOptions: PropTypes.array.isRequired,
  filterSort: PropTypes.array.isRequired,
};

NetworkActionsBarFilters.defaultProps = {
  hideServiceTypeFilter: false,
};

export default NetworkActionsBarFilters;
